var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "filter-control-template",
    {
      staticClass: "filter-col-sm",
      attrs: {
        field: _vm.field,
        type: "number",
        predicate: _vm.predicate,
        pillFormatter: _vm.pillFormatter,
        computedField: _vm.computedField,
        multiple: false,
        color: _vm.color,
        placeholder: _vm.placeholder,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }